/**
 * O arquivo de alerta da aplicação. Dois consumidores: o painel de retirada ao
 * vivo (um pedido de retirada novo) e o mini-monitor destacado (uma recusa que
 * ainda pode ser liberada).
 */
const ALERT_SOUND_URL = '/assets/audio/alertSound.mp3';
const ALERT_SOUND_VOLUME = 0.7;

/**
 * Toca o alerta. O navegador pode recusar — sem um gesto do usuário na página,
 * a reprodução automática é bloqueada —, e aí o aviso vai para o console com o
 * nome de quem pediu, sem quebrar mais nada.
 *
 * @param requester Quem pediu o som, para o aviso no console.
 */
export function playAlertSound(requester: string): void {
  try {
    const audio = new Audio(ALERT_SOUND_URL);
    audio.volume = ALERT_SOUND_VOLUME;
    audio.play().catch((err) => {
      console.warn(
        `[${requester}] alert sound playback blocked or failed:`,
        err
      );
    });
  } catch (err) {
    console.warn(`[${requester}] alert sound init failed:`, err);
  }
}
